import { type Virtualizer } from "@tanstack/react-virtual"
import { createContext } from "react"

export const VirtualListContext = createContext<{
  offset: number
  rowVirtualizer: Virtualizer<HTMLElement, Element> | null
} | null>(null)
